// Identifiants de tracking (tagId) réutilisés dans plusieurs fichiers — centralisés ici pour éviter
// toute divergence si l'un d'eux change côté CRUD analytics_tracking (mêmes conventions que module.js).
export const analyticsTagsConstantes = Object.freeze({
  DOCUMENT_DOWNLOAD: "KpL7nYpPSOVZ9T06",
  ABSENCE_JUSTIFY: "zeR5xowywOtCASsK",
  ABSENCE_JUSTIFY_SAVE: "K1wVgXIUQD0pIXik",
  EDITOR_LIST_BULLET: "SIU0gAV8imgJr1ue",
  EDITOR_LIST_NUMBERED: "hTwKcF5D7Bt2sgfx",
  EDITOR_LINK_INSERT: "MpulKlIadykEWaRH",
  EDITOR_IMAGE_INSERT: "ryJXdHck8iRh7vbj",
  EDITOR_MEDIA_INSERT: "DEwqyjsGnDTEiBd4",
  TABS_MODULE_MESSAGE: "GCkCPgWUxgrX9z3s",
  TABS_MODULE_ABSENCE: "ovMMrLGB6TtQP43y",
  TABS_MODULE_GRADEBOOK: "WoMGSGbwvyKvllOo",
  TABS_MODULE_SKILL: "6VdrGmjBVayU1djW",
  TABS_MODULE_COURSE: "JNWxa8hnZYdKtLuh",
  TABS_MODULE_DOCUMENT: "VVptPZsJJKSTswAF",
  TABS_MODULE_NOTEPAD: "4ohwTKcd80qcuG2X",
  TABS_MODULE_WEBLINKS: "BZsD94SKdoFtSLfz",
  ABSENCE_PLANNING_EXPORT: "ttKoyT5yWMmadqHl",
  ABSENCE_LIST: "YJ3m4fd35ckc1eNw",
  CHAT_CREATE_MESSAGE: "bBptJ4E3bQqytiAL",
  CHAT_OPEN_MESSAGE: "tiIoQ5hfbTgUcEyR",
  TRAINING_COURSE_INFO_PRESENTATION: "vfU0t7vp355ird3O",
  TRAINING_COURSE_INFO_CONTACT: "kbDAcMaPLB4RdmVx",
  TRAINING_COURSE_INFO_PARTNER: "HzNQLcpKg1UkFq3n",
  TRAINING_COURSE_INFO_COMMUNICATION: "D5pTeDPSB1Eg3O6L",
  SKILL_SYNTHESIS: "pCWD8njQ5OfaaHOz",
  SKILL_EXPORT_PDF: "WYfNqOS6zLZQ5YeR",
  SKILL_EXPORT_EXCEL: "ehFC5wTXBFkVCDqV",
  SKILL_SAVE: "caKIKuSbw1Ctz2CR",
  ABSENCE_CERTIFICATE_DOWNLOAD: "NMqLHjn2MnbkFhmw",
  HEADER_THEME_DARK: "gzsfvtZjUCAEhTR1",
  HEADER_THEME_SYSTEM: "csBF1uZI0iHKqq5v",
  HEADER_THEME_LIGHT: "k0Rki33wPhK7OI08",
  QUESTIONNAIRE_SIGN: "TNW8k3SlA7gIRMFL",
  QUESTIONNAIRE_COMPLETE: "WViAhOmsfHr2oiIa",
  SKILL_COMPLETE: "DTU9bJqcmEoa6HX1",
  NOTEPAD_NEW_NOTE: "aCaDbohGPTIqZke9",
  TABS_HEADER_HOME: "IA9hYQv1ipru4rBM",
  WEBLINKS_OPEN: "iJ79ClWkZDnIjmjH",
  LESSON_ATTACHMENT_DOWNLOAD: "LxuiC3tMAMwgsUC0",
  LESSON_WATCH: "Awa2rWci01S4EDRh",
  DOCUMENT_NEW: "8wLSmCEUYL9VmuQY",
  DOCUMENT_DOWNLOAD_FILE: "iTHdZX26doVnfX7k",
  PROFILE_UPDATE: "aOqQYSM5XpON4UOW",
  CHAT_REPORT_MESSAGE: "8LaUc3nJ0oDmCU2V",
  QUESTIONNAIRE_EXPORT_PDF: "BDGDIncgKfonPiN9",
  QUESTIONNAIRE_EXPORT_PDF_MODEL: "iUQwvRoCRhRuAKhv",
  QUESTIONNAIRE_REPLY_SAVE: "1aLskp4zwlMS8wsy",
  ADMIN_HOME_VIEW: "53dGXsdCDfT9oxHO",
  ABSENCE_LIST_JUSTIFY_OPEN: "LnstCUI0lXqbIwbf",
  ABSENCE_LIST_JUSTIFY_FORM: "yr6nwu6HEgY9nWgD",
  ABSENCE_LIST_ADD_OPEN: "ZM6agTa9V3Bopzgj",
  ABSENCE_LIST_ADD_FORM: "QP3adGYP3ZR9xBVr",
  ABSENCE_CALENDAR_EVENT_CLICK: "ZkYVLQ4AGlsB5ORy",
  ABSENCE_CALENDAR_JUSTIFY: "LMpBYSnT5QbG3ojz",
  ABSENCE_EMARGEMENT_EVENT_CLICK: "xihpFrd3X0EBIqvi",
  ABSENCE_EMARGEMENT_JUSTIFY: "ABQnsr8pSYKbKhfC",
  CHAT_FILE_ADDED: "4oZQrPqaMPDcGGGO",
  CHAT_SEND_MESSAGE: "pismgBZQL8w2Ya8E",
  CHAT_PRIVATE_REPLY_OPEN: "UAmsMnTC7hEoB1Mc",
  DOCUMENT_CREATE: "QkMd5e6n0wM6S3mp",
  NOTEPAD_OPEN_NOTE: "TQPnXSJdeBonpPnV",
  NOTEPAD_SAVE: "YGzsOmoaH40BxNkM",
  NOTEPAD_PIN: "jC3xWrv14Nbo2qmK",
  DASHBOARD_DOWNLOAD_BOOKLET: "iTFkOz7ll5jRxkbo",
  DASHBOARD_DOWNLOAD_KEY_DATES: "JnOi8Dz6YXu2j93F",
  DASHBOARD_DOWNLOAD_BOOKLET_ZIP: "FBQrZAuOSpbl4YuP",
  GRADEBOOK_EXPORT_PDF: "Km3f0cSj5JUeEtW4",
  ADMIN_STATS_ARROW_CLICK: "4OLre7PLOBHVOFf6",
  ADMIN_STATS_QUESTIONNAIRE_RATE_COMPONENT: "1nxqA0rO2Hcnkp1m",
  ADMIN_STATS_QUESTIONNAIRE_RATE_PROFILE: "iVA51SgKGIWWfSn3",
  ADMIN_STATS_QUESTIONNAIRE_RATE_PROMOTION: "mhXaBJEzIIu2RIqH",
  ADMIN_STATS_QUESTIONNAIRE_RATE_PROMOTION_PROFILE: "Y53YAGvztroFsOed",
  ADMIN_STATS_QUESTIONNAIRE_RATE_PROMOTION_PROFILE_DOWNLOAD: "Wkxbe0MnqoQvPz8C",
  ADMIN_STATS_QUESTIONNAIRE_RATE_ESTABLISHMENT: "dRW4u6lGeT7zmhf7",
  ADMIN_STATS_QUESTIONNAIRE_RATE_TRAINING: "fEE2ZFjHdZ03z7FD",
  ABSENCE_CERTIFICATE_DOWNLOAD_FILE: "JSzLta9bJmmYUUyu",
  GRADEBOOK_EXPORT_PDF_DOWNLOAD: "ey1bFfVTcmly0o4p",
  SKILL_EXPORT_EXCEL_DOWNLOAD: "e4SYDWMIrdnNBqDo",
  SKILL_EXPORT_PDF_DOWNLOAD: "v2b3k8r4a2VWyuBQ",
  QUESTIONNAIRE_EXPORT_PDF_MODEL_DOWNLOAD: "caHSb6flMT3lanKi",
  QUESTIONNAIRE_EXPORT_PDF_DOWNLOAD: "5188xitEiR2IH5gi",
  PILOT_HOME_EMAILS: "ZbcNAEPxhdwdRNf5",
  PILOT_HOME_MODULE_ABSENCE_SETTINGS: "WfgZfF7bZgS1Ung3",
  PILOT_HOME_MODULE_ABSENCE_ENABLED: "vTcipTUVwk0B9ilh",
  PILOT_HOME_MODULE_GRADEBOOK_SETTINGS: "1dSadRu7EJIfSEwj",
  PILOT_HOME_MODULE_GRADEBOOK_ENABLED: "mRAHuSD9e6RqFZFK",
  PILOT_HOME_MODULE_SKILL_SETTINGS: "QEGaQB2AjqKUsc0C",
  PILOT_HOME_MODULE_SKILL_ENABLED: "fPp2dgPwX8IrRmGX",
  PILOT_HOME_MODULE_COURSE_SETTINGS: "Edvd7I9K7FciBxdL",
  PILOT_HOME_MODULE_COURSE_ENABLED: "YpDWvobkpJKWSGzi",
  PILOT_HOME_MODULE_CONTRACT_BREAK_SETTINGS: "hlkwfdxtEqpx1LI2",
  PILOT_HOME_MODULE_CONTRACT_BREAK_ENABLED: "tQqDnPPE0yVBoVlA",
  PILOT_HOME_MODULE_DOCUMENT_SETTINGS: "GI3RxoCHtS5R4632",
  PILOT_HOME_MODULE_DOCUMENT_ENABLED: "kKuwZNBGOdUcSWKj",
  PILOT_HOME_MODULE_REGISTRATION_ENABLED: "0chQQLwxrQQaXcXB",
  PILOT_HOME_MODULE_NOTEPAD_ENABLED: "csoPzTCdiX2zGQH9",
  PILOT_HOME_MODULE_WEBLINKS_SETTINGS: "ZBIZHRtV2yw9m3b8",
  PILOT_HOME_MODULE_WEBLINKS_ENABLED: "oZhCM6BUlnsqJ44O",
  PILOT_HOME_MODULE_MESSAGE_SETTINGS: "oCcTFA7iczIjm3td",
  PILOT_HOME_MODULE_MESSAGE_ENABLED: "6eXbQbOx7K5BWCvF",
  PILOT_HOME_MODULE_QUESTIONNAIRE_SETTINGS: "MfFPc5iVOjOgCzPz",
  PILOT_HOME_MODULE_QUESTIONNAIRE_ENABLED: "U2fsx0nRp6B7MNWw",
  PILOT_HOME_DASHBOARD: "Y4fyTM4yEXzZrhqB",
  PILOT_HOME_GRADEBOOK_DASHBOARD: "agXDiuaAVoV1HTvf",
  PILOT_DASHBOARD_INDICATOR_CONNECTION_RATE: "moFBiYcnBUMAypcS",
  PILOT_DASHBOARD_INDICATOR_SKILL_RATE: "DzlE3b889dRZqjuW",
  PILOT_DASHBOARD_INDICATOR_QUESTIONNAIRE_RATE: "kAeKOy4HmtGTqTTw",
  PILOT_DASHBOARD_INDICATOR_TRIAD_RATE: "6Xt6GoL9CHH8ZJz4",
  PILOT_DASHBOARD_TRAINING_LIST: "NvCn3egegBK0Zrxf",
  PILOT_DASHBOARD_REGISTRATION: "WPytiVRBKfSNj11y",
  PILOT_DASHBOARD_DATA_DUPLICATION: "Faos9ilk5YjRhzhS",
  PILOT_DASHBOARD_DRIVING_LICENSE_AID: "uT1Zflwj4Q1dZPfB",
  PILOT_DASHBOARD_SHARED_DOCUMENTS: "VriEzcRWYrOfXdaP",
  PILOT_DASHBOARD_VIGILANCE_SHEETS: "FunrSGl7u1JV1ler",
  PILOT_SHARED_DOCUMENT_ADD_FORM: "Gct8U0qXHK3QIRa9",
  PILOT_SHARED_DOCUMENT_EDIT: "wNnONjBVpxJc9IJl",
  PILOT_SHARED_DOCUMENT_SEARCH: "Wl5zPpcoXvrjq535",
  PILOT_SHARED_DOCUMENT_DELETE: "KJSFjK77mvqw3JIV",
  PILOT_SHARED_DOCUMENT_DOWNLOAD: "3pi865LaaTlphnNr",
  PILOT_TRIAD_PROMOTION_SEARCH_TRAINING_FORM: "hO75XjI59FBuMi5b",
  PILOT_TRIAD_PROMOTION_ARCHIVED: "BuxLl3Sqv4TJETlH",
  PILOT_SETTINGS_THEME_CONTACT_DISPLAY: "STktawKdQHwCJwTM",
  PILOT_SETTINGS_THEME_CONTACT_DISPLAY_FORM: "VYCC2Y7WjMqCzDtl",
  PILOT_SETTINGS_THEME_DOCUMENT_DISPLAY: "ma5mQJ0O55lPsinw",
  PILOT_SETTINGS_THEME_DOCUMENT_DISPLAY_FORM: "lWJA0GrtlkM9ceI4",
  PILOT_SETTINGS_THEME_INFORMATION_DISPLAY: "1lIcruZ58YVYsvDF",
  PILOT_SETTINGS_THEME_INFORMATION_DISPLAY_FORM: "maQnZXyJyt6SD7IZ",
  PILOT_SETTINGS_THEME_PARTNER_DISPLAY: "CNcStvwzHRNWDpb4",
  PILOT_SETTINGS_THEME_PARTNER_DISPLAY_FORM: "LBNHdTvcooF0EUg7",
  PILOT_SETTINGS_THEME_PRESENTATION_DISPLAY: "0wHe2hwabzrIcoI0",
  PILOT_SETTINGS_THEME_PRESENTATION_DISPLAY_FORM: "jHsUCX0LbocLjoEX",
  PILOT_SETTINGS_SUBJECT_ACTIONS_ADD_SUBJECT_FORM: "Hv29JIukMka8gHic",
  PILOT_SETTINGS_SUBJECT_ACTIONS_ADD_UNIT_FORM: "QQk7OaJS1DwTyWES",
  PILOT_SETTINGS_SUBJECT_ADD_SUBJECT_FORM: "3Con8NbmN1IutiIS",
  PILOT_SETTINGS_SUBJECT_EDIT_SUBJECT_FORM: "ZEwEVJpbtdD68vtw",
  PILOT_SETTINGS_SUBJECT_EDIT_UNIT_FORM: "CmwM2fj24OVa4OU4",
  PILOT_SETTINGS_SUBJECT_DELETE_SUBJECT_FORM: "WU6NRAQ3E7qFnqbg",
  PILOT_SETTINGS_SUBJECT_DELETE_UNIT_CONFIRM: "kQdjuMQztje4Mfnp",
  PILOT_TRIAD_CREDENTIALS_SEND_WELCOME_EMAIL: "66xObtaccnJr5hIF",
  PILOT_TRIAD_CREDENTIALS_RESET_PASSWORD: "y89KzW0biEd3fjoI",
  PILOT_TRIAD_ADD_GROUP_FORM: "UOssDuY2OHO52H1E",
  PILOT_TRIAD_ADD_TRIAD_FORM: "iFVZtmW51pEvA6Xv",
  PILOT_TRIAD_ADD_TEST_TRIAD: "eolnohp3fmat0WCD",
  PILOT_TRIAD_ADD_USER_FORM: "I7332MX6dGlO1CwE",
  PILOT_TRIAD_COMPLETE_FORM: "dluX42P3v1dOrH2M",
  PILOT_TRIAD_EXPORT: "Hr2gfiHQEmHL78Hx",
  PILOT_TRIAD_EXPORT_DOWNLOAD: "EAbI4qaGPwxfGqSW",
  PILOT_TRIAD_IMPORT_FORM: "sBuTKSpZNrI0Cy7k",
  PILOT_TRIAD_IMPORT_MODEL_DOWNLOAD: "ntvb0DNnbKX2h0qm",
  PILOT_TRIAD_DELETE_ALL_CONFIRM: "6KXqTYo2IL3r46AM",
  PILOT_TRIAD_ADD_MEMBER: "iTUx5Fc2pxW2eUdf",
  PILOT_TRIAD_CONTRACT_MANAGEMENT: "1r8N91opKlxF0ZMP",
  PILOT_TRIAD_IMPERSONATE_USER: "6J6POGZgqjCiuXT0",
  PILOT_TRIAD_EDIT: "ROmjVRYIw5o3Z7Yr",
  PILOT_TRIAD_DELETE_ALL_COMPANY_TUTORS: "iE4Mvv5RS1UIwcGU",
  PILOT_TRIAD_DELETE_ALL_TEACHING_TUTORS: "G7c6m77dpk5NXvlA",
  PILOT_TRIAD_DELETE: "gQkqQglcwErG1R3A",
  PILOT_TRIAD_DELETE_COMPANY_TUTOR: "T3gi7gJl6WBbc4eJ",
  PILOT_QUESTIONNAIRE_ADD: "M76SLZHSeiiDgkqN",
  PILOT_QUESTIONNAIRE_ADD_FORM: "gWdkUGy3H2o0EkBc",
  PILOT_QUESTIONNAIRE_ADD_CATEGORY_FORM: "lvhpCTrdVRYpZPO9",
  PILOT_QUESTIONNAIRE_DUPLICATE: "c5RGrfdCJupCNc2e",
  PILOT_QUESTIONNAIRE_DUPLICATE_CATEGORY: "7cjFfX8RKJNDe3Pa",
  PILOT_QUESTIONNAIRE_IMPORT_FORM: "cSDIpqCMuaK0wGxN",
  PILOT_QUESTIONNAIRE_EDIT_CATEGORY_FORM: "lomUvK5maqq1m8fd",
  PILOT_QUESTIONNAIRE_DELETE_CATEGORY_CONFIRM: "a0Y2NjuiXPGRVKTY",
});
